import { Dispatch } from 'react';
import { IBaseScoreSection, IBaseVariableSection } from 'src/services/api/api-client';
import { createContext } from 'use-context-selector';

export type ScoreContextType = {
  scoreSections: IBaseScoreSection[] | undefined;
  setScoreSections: Dispatch<React.SetStateAction<IBaseScoreSection[] | undefined>>;
  variables: IBaseVariableSection[] | undefined;
  setVariables: Dispatch<React.SetStateAction<IBaseVariableSection[] | undefined>>;
};

const defaultValues: ScoreContextType = {
  scoreSections: [],
  setScoreSections: () => {},
  variables: [],
  setVariables: () => {},
};

export const ScoreContext = createContext(defaultValues);
